import React from 'react';

export const RESOLUTIONS = [
    {key: 'hw1', media: '(min-width: 769px)'}, // width: 1280
    {key: 'hw2', media: '(min-width: 376px) and (max-width: 768px)'}, // width: 768
    {key: 'hw3', media: '(max-width: 375px)'} // width: 375
];

export function HeroImage({urlTemplate, altText, defaultImage, showTest}) {
    const isIE11 =
        typeof window !== 'undefined' &&
        !!window.navigator.userAgent.match(/Trident\/7\./);

    // Return blurred default image
    if (!urlTemplate) {
        return (
            <picture className="hero-image">
                {isIE11 ? (
                    <svg className="hero-image__img hero-image__img--blur">
                        <defs>
                            <filter id="blur">
                                <feGaussianBlur stdDeviation="4" />
                            </filter>
                        </defs>
                        <image
                            xlinkHref={defaultImage}
                            width="1024"
                            height="768"
                            filter="url(#blur)"
                        />
                    </svg>
                ) : (
                    <img
                        className="hero-image__img hero-image__img--blur"
                        src={defaultImage}
                        alt={altText}
                    />
                )}
                <div className="hero-image__overlay" />
            </picture>
        );
    }

    const sources = RESOLUTIONS.map(({key, media}) => ({
        key,
        media,
        srcSet: urlTemplate.replace('${templateId}', (showTest && key === 'hw3') ? 'hw6' : key)
    }));

    return (
        <picture className="hero-image">
            {sources.map((props) => <source {...props} />)}
            <img
                className="hero-image__img"
                src={sources[0].srcSet}
                alt={altText}
            />
        </picture>
    );
}
